<div class="d-flex justify-content-center align-items-center pt-4">
  <div class="w-25 text-center">
    <img [attr.src]="image" alt="Image error description" />
    <h1 class="mt-3">{{ title }}</h1>
    <p>
      {{ description }}
    </p>
    <ul class="list-unstyled d-flex justify-content-center gap-4 mt-2">
      <li>
        <ap-button
          btnType="text"
          [label]="'not-found-page.view-directory' | translate"
          (onClick)="redirectToRoot()" />
      </li>
      <li>
        <ap-button
          btnType="primary"
          [label]="'not-found-page.go-back' | translate"
          (onClick)="goBack()" />
      </li>
    </ul>
  </div>
</div>
